<template>
  <header class="booking-header">
    <div class="booking-header-content page-background">
      <!-- Logo Container -->
      <div class="booking-logo-container">
        <img :src="currentLogoUrl" :alt="`${businessName} logo`" class="booking-logo" />
      </div>

      <!-- Place and Business Name -->
      <div class="booking-header-text">
        <h1 class="booking-place-name">{{ placeName }}</h1>
      </div>
    </div>
  </header>
</template>

<script setup lang="ts">
import { usePlace } from '@/composables/usePlace';

const {
  placeName,
  businessName,
  currentLogoUrl
} = usePlace();
</script>

<style scoped>
.booking-header {
  position: relative;
  padding: 3rem 0 0;
  z-index: 10;
  margin-bottom: 0rem;
}

.booking-header-content {
  padding-top: 2.8rem; /* Space for bottom half of logo */
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  margin: 0 auto;
  gap: 0.5rem;
  padding-bottom: 1.2rem;
}

.booking-logo-container {
  position: absolute;
  left: 50%;
  transform: translateX(-50%);
  top: 5%;
  width: 4.8rem;
  height: 4.8rem;
  border-radius: 50%;
  display: flex;
  justify-content: center;
  align-items: center;
  flex-shrink: 0;
  background-color: transparent;
  overflow: hidden;
}

.booking-logo {
  max-width: 5rem;
  max-height: 5rem;
  object-fit: contain;
}

.booking-header-text {
  text-align: center;
}

.booking-place-name {
  font-size: 1.18rem;
  font-weight: 600;
  line-height: 1.2;
  color: var(--booking-heading-color, #212529);
  margin-bottom: 0.25rem;
}

.booking-business-name {
  font-size: 0.9rem;
  font-weight: 500;
  color: var(--booking-text-secondary);
  line-height: 1.4;
}

/* Dark mode specific styles */
@media (prefers-color-scheme: dark) {
  .booking-top-bar {
    background-color: var(--place-primary);
  }
}

/* Responsive adjustments */
@media (max-width: 640px) {
  /* Add any additional styles needed for tablet/mobile */
}

@media (max-width: 360px) {
  .booking-logo-container {
    width: 4rem;
    height: 4rem;
  }

  .booking-logo {
    max-width: 3rem;
    max-height: 3rem;
  }

  .booking-place-name {
    font-size: 1rem;
  }

  .booking-business-name {
    font-size: 0.8rem;
  }
}
</style>
